import React from 'react';
// import Quote from '../../Assets/Images/testimonial-quote-icon.avif';
import ClientReviewList from '../../Utils/ClientReviewList';
import { CONSTANT } from '../../Utils/Constant';
import './Testimonial.scss';

const Testimonial = () => {
  return (
    <div className="testimonial">
      <div className="container">
        <div className="testimonial-common-div">
          {ClientReviewList.map((item, index) => {
            return (
              <div
                key={index}
                className="testimonial-container"
                style={{
                  margin:
                    ClientReviewList?.length % 2 !== 0 && ClientReviewList?.length - 1 === index
                      ? '30px 19.35px'
                      : '30px auto'
                }}
                data-aos="fade-up"
                data-aos-duration={'1' + (index + 1) + '00'}
                data-aos-once="true">
                <div className="testimonial-content">
                  <div className="testimonial-photo">
                    <img
                      className="client-img"
                      src={item.clientImg}
                      alt={item.clientName + ' photograph'}
                      title={`Client | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`}
                    />
                  </div>
                  <div className="review-text">
                    {/* <img
                      src={Quote}
                      alt={'Quote | ' + CONSTANT.PIXERFECT_SOLUTIONS_LLP}
                      title={'Quote | ' + CONSTANT.PIXERFECT_SOLUTIONS_LLP}
                      className="quote-start"
                    /> */}
                    <p>{item.clientReview}</p>
                    {/* <img
                      src={Quote}
                      alt={'Quote | ' + CONSTANT.PIXERFECT_SOLUTIONS_LLP}
                      title={'Quote | ' + CONSTANT.PIXERFECT_SOLUTIONS_LLP}
                      className="quote-end"
                    /> */}
                  </div>
                  <div className="testimonial-detail">
                    <div className="client-info">
                      <img
                        src={item?.testimonialLogo}
                        alt={item?.projectName + ' logo'}
                        title={item?.projectName}
                        className="client-logo"
                      />
                      <div className="client-text">
                        <p className="client-name">{item?.clientName}</p>
                        <p className="client-position">{item?.clientPosition}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
